import api from '@mint-lib/api';
import { useQuery } from '@mint-lib/query-client';
import { useFlags, useService } from '@mint-lib/routing-context';
import { AdFormIntegrations } from '@mint-sdk/api-integrations';

import { AdFormResponseSchema } from '../../schemas/integrations.js';

const getIntegrations = async () => {
  const { data } = await api.get(`/api/adform/v2/integrations/`);

  return AdFormResponseSchema.parse(data);
};

export const useGetAdFormIntegrations = ({ enabled }: { enabled: boolean }) => {
  const ff = useFlags('@mint/arm', ['integrationsQuerySdk']);
  const isIntegrationSdkEnabled = ff?.integrationsQuerySdk?.enabled;

  const [queryClient] = useService({
    name: 'queryClient',
    suspense: true,
  });

  const { data, isLoading } = useQuery({
    queryKey: ['adform_ad_server', 'adform'],
    queryFn: getIntegrations,
    enabled: enabled && !isIntegrationSdkEnabled,
  });

  const { data: adFormIntegrations, isLoading: adFormLoading } = useQuery(
    {
      ...AdFormIntegrations.getQueryOptions({}),
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      enabled: enabled && isIntegrationSdkEnabled,
    },
    queryClient,
  );

  if (isIntegrationSdkEnabled) {
    return {
      data: adFormIntegrations,
      isLoading: adFormLoading,
    };
  }

  return {
    data,
    isLoading,
  };
};
